import { resolveImagePath } from '@/utils/imageResolver';

export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-start">
      {/* Hero Background Image - Optimized for LCP */}
      <img
        src={resolveImagePath('/images/hero-bg.jpg')}
        alt="Elvis Water Taxi Service in beautiful Exuma waters"
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay to ensure text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Elvis Water Taxi Service
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg md:text-xl lg:text-2xl text-white mb-8 leading-relaxed">
            Providing daily water taxi service from the Exuma Yacht Club.
          </p>
          
          {/* CTA Button - Optional based on design */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="#services" 
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200"
            >
              Explore Our Services
            </a>
            <a
              href="tel:+1-242-464-1558"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-black/80 border-2 border-white hover:bg-white hover:text-gray-900 rounded-lg transition-colors duration-200"
            >
              Call +1-242-464-1558
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </section>
  );
}